export function useShortsNavigation() {
	const router = useRouter();

	function navigateToShorts(query?: Record<string, string>): void {
		router.push({ path: '/shorts', query });
	}

	function navigateToVideo(propertyId: string): void {
		router.push(`/shorts/${propertyId}`);
	}

	return { navigateToShorts, navigateToVideo };
}
